import { Box } from '@mui/material';
import { AdviseCurrentSpend } from '../../../../types/advise';
import { isSourcedSpend } from './currentMonthlyCxSpend.calc';
import { IncompleteSuppliersWarning } from './IncompleteSuppliersWarning';
import { SourcedCxSpend } from './SourcedCxSpend';
import { TypedCxSpend } from './TypedCxSpend';

export interface CurrentMonthlyCxSpendFieldProps {
  spend?: AdviseCurrentSpend;
  typed: number | null;
  canEdit: boolean;
  onType: (amount: number | null) => void;
  onOverride: (monthlyAmount: number) => Promise<boolean>;
  onReset: () => Promise<boolean>;
  // Left out where the Current Suppliers tab isn't shown.
  onGoToCurrentSuppliers?: () => void;
}

/** ROI's current spend: filled from Current Suppliers when it has a baseline, otherwise typed by the Advisor. */
export const CurrentMonthlyCxSpendField = ({
  spend,
  typed,
  canEdit,
  onType,
  onOverride,
  onReset,
  onGoToCurrentSuppliers
}: CurrentMonthlyCxSpendFieldProps) => (
  <Box className="flex flex-col gap-2">
    {isSourcedSpend(spend) ? (
      <>
        <IncompleteSuppliersWarning
          names={spend.incomplete_suppliers}
          onGoToCurrentSuppliers={onGoToCurrentSuppliers}
        />
        <SourcedCxSpend
          spend={spend}
          canEdit={canEdit}
          onOverride={onOverride}
          onReset={onReset}
        />
      </>
    ) : (
      <TypedCxSpend
        typed={typed}
        canEdit={canEdit}
        onType={onType}
      />
    )}
  </Box>
);
